import { queryDataExt } from "../BaseService/index";
const GlobalConfig = new window.globalConfig();

export const getTestFieldsWithConditions = async (
  whereClause,
  selectFields,
  sortFields
) => {
  return await queryDataExt(
    `${GlobalConfig.REACT_APP_API_TEST_FIELD_URL}getWithConditions`,
    whereClause,
    selectFields,
    sortFields
  );
};